import React from 'react';
import { Box, Text, useColorModeValue } from '@chakra-ui/react';
import { ListingFormat, ListingType } from '@Encore-FastStartup-Phase-Out/encore-shared';

import { Colors } from '../../theme/colors';

type PillProps = {
  type: ListingType;
  format?: ListingFormat;
};

const ListingTypePill = ({ type, format }: PillProps) => {
  const isAuction = type === ListingType.AUCTION;
  const isGiveaway = type === ListingType.GIVEAWAY;
  const isFlash = format === ListingFormat.FLASH;

  const textColorAuction = useColorModeValue(
    Colors.light.primary,
    Colors.dark.primary
  );
  const textColorBuyNow = useColorModeValue(
    Colors.light.secondary,
    Colors.dark.secondary
  );

  const color = isAuction ? textColorAuction : textColorBuyNow;

  const label = isAuction
    ? isFlash ? 'Flash Auction' : 'Auction'
    : isGiveaway
      ? isFlash ? 'Flash Giveaway' : 'Giveaway'
      : 'Buy Now';

  return (
    <Box
      display="inline-block"
      px="20px"
      py="4px"
      bg="transparent"
      color="white"
      borderRadius="full"
      border={`1px solid ${color}`}
    >
      <Text color={color}>{label}</Text>
    </Box>
  );
};

export default ListingTypePill;
